// extracted by css-extract-rspack-plugin
export default {"root":"L9OGd","item":"xJKQ9","link":"AQeC_","icon":"HXyYm"};